import { useMutation, useQueryClient } from 'react-query';
import request from '../../../helpers/request';
import { getQueryKeys } from '../queries/queryKeys';

export const addClientDocuments = async ({ clientId, documentType, files }) => {
  return await Promise.allSettled(
    files.map((file) => {
      const formData = new FormData();
      formData.append('file', file.originFileObj);

      return request.post(
        `/HousingStock/client/documents/${clientId}`,
        formData,
        `При загрузке документа ${file.originFileObj.name} произошла ошибка`,
        {},
        null,
        { documentType }
      );
    })
  );
};

export const useAddClientDocuments = () => {
  const queryClient = useQueryClient();
  const addMutation = useMutation(addClientDocuments, {
    onSuccess: (_, { clientId }) => {
      queryClient.invalidateQueries(getQueryKeys.clientDocuments(clientId));
    },
  });

  return {
    addClientDocuments: addMutation.mutateAsync,
    loading: addMutation.isLoading,
  }
};
